const UpdateTableIcon = () => {
  return (
    <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.9585 11.0001L0.208496 6.25008L1.396 5.06258L4.9585 8.62508L12.6043 0.979248L13.7918 2.16675L4.9585 11.0001Z"
        fill="white"
      />
    </svg>
  );
};

export default UpdateTableIcon;
